import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './../material.module';
import { AppRoutingModule } from './../app-routing.module';

import { NavbarComponent } from './navbar/navbar.component';
import { PipesModule } from './../pipes/pipes.module';
import {
  DialogConfirmChangesComponent,
  DialogConfirmCancelComponent,
  DialogConfirmDeleteComponent,
  UserProfileComponent,
  DialogStaticNotificationsComponent,
  DialogDynamicNotificationsComponent,
  CustomSnackbarComponent,
  ConfirmationDialogComponent,
  ConfirmUserPinComponent,
} from './index.shared';
import { DirectiveModule } from './../directive/directive.module';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
  declarations: [
    NavbarComponent,
    DialogStaticNotificationsComponent,
    DialogDynamicNotificationsComponent,
    DialogConfirmChangesComponent,
    DialogConfirmCancelComponent,
    DialogConfirmDeleteComponent,
    UserProfileComponent,
    CustomSnackbarComponent,
    ConfirmationDialogComponent,
    ConfirmUserPinComponent,
  ],
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      DirectiveModule,
      AppRoutingModule,
      MaterialModule,
      TranslateModule,
      PipesModule,
  ],
  exports: [
    PipesModule,
    TranslateModule,
    NavbarComponent,
    DialogStaticNotificationsComponent,
    DialogDynamicNotificationsComponent,
    DialogConfirmChangesComponent,
    DialogConfirmCancelComponent,
    DialogConfirmDeleteComponent,
    UserProfileComponent,
    CustomSnackbarComponent,
    ConfirmationDialogComponent,
    ConfirmUserPinComponent,
  ]
})
export class SharedModule { }
